export default {
    title: "Seu gerente de aprovação é {email}"
}